import React from 'react'
import Service from './Service'

export default function () {
  return (
    <Service/>
  )
}
